<template>
  <div>
    <h4>{{ timezone }}</h4>
    <h2 class="pt-2">
      {{ date.format('hh:mm') }}<span class="pl-1 clock-ampm">{{ date.format('A') }}</span>
    </h2>
    <v-tooltip left v-if="event">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" x-small color="primary" class="mr-1">mdi-calendar-star</v-icon>
      </template>
      <span style="white-space: pre-wrap;">{{ event }}</span>
    </v-tooltip>
    <span class="caption font-weight-medium">{{ date.format('ddd, DD MMMM') }}</span>
  </div>
</template>
<script>
import moment from 'moment-timezone';
export default {
  data() {
    return {
      ticker: null,
      date: this.getDateInTimezone()
    };
  },
  props: {
    timezone: String,
    event: String || null
  },
  methods: {
    getDateInTimezone() {
      return moment.utc().tz(this.timezone);
    }
  },
  created() {
    this.ticker = setInterval(() => {
      this.date = this.getDateInTimezone();
    }, 1000);
  },
  destroyed() {
    clearInterval(this.ticker);
  }
};
</script>
<style lang="scss" scoped>
  .clock-ampm {
    font-size: 13px;
  }
  h4, span {
    line-height: 1 !important;
  }

  div {
    justify-content: center;
  }
</style>
